import { httpClient } from '@/services/http/client'
import { buildApiUrl, ApiService } from '@/config/api.config'
import type { City } from '@/types/entities/city'

/**
 * Значения фильтров для жилых комплексов
 * Реальная структура от backend
 */
export interface FilterValues {
  price?: {
    min?: string  // Backend возвращает строку "100000"
    max?: string  // Backend возвращает строку "45000000"
  }
  numberOfRooms?: string[]
  cities?: City[]  // [{ id, name }]
  projectTypes?: string[]  // ["PROJECT_TYPE_RESIDENTIAL_COMPLEX", ...]
  // Могут быть добавлены:
  // minArea, maxArea, handoverYears, projectRank, inboundAmenities, features
}

/**
 * API методы для фильтров жилых комплексов
 */
export const filterApi = {
  /**
   * Получить значения фильтров
   */
  async getFilterValues(): Promise<FilterValues> {
    const url = buildApiUrl(
      ApiService.Properties,
      'properties/residential-complex-filter-values'
    )
    return httpClient.get<FilterValues>(url)
  },
}
